import script from "./WidgetLibrary.vue?vue&type=script&setup=true&lang=js"
export * from "./WidgetLibrary.vue?vue&type=script&setup=true&lang=js"

import "./WidgetLibrary.vue?vue&type=style&index=0&id=d7d33088&lang=css"

const __exports__ = script;

export default __exports__